import actionTypes from '../types/common'

export const setSidebarToggle = (isVisible = true) => ({
  type: actionTypes.SET_SIDEBAR_TOGGLE,
  payload: {
    showSidebar: isVisible,
  },
})
